import styled from 'styled-components';
import { Mentions } from 'antd';

export const HeaderContainer = styled.div`
  display: flex;
`;

export interface TextareaAttributeProps {
  placeholder: string;
  autoSize: any;
}

export const TextareaMentions = styled(Mentions).attrs(
  (props: TextareaAttributeProps) => ({
    placeholder: props.placeholder || 'Tulis ide kamu di sini...',
    autoSize: { minRows: 3 },
  }),
)`
  border: none !important;
  box-shadow: none !important;
  font-family: 'ProximaNovaRg';
  margin-bottom: 12px;
  resize: none;
  width: 100%;

  textarea {
    padding: 18px 26px;
  }

  :focus {
    outline: none;
  }
`;

export const MentionSuggestionResult = styled.div`
  > div {
    .ant-mentions-dropdown-menu-item {
      border-bottom: 1px solid #f5f6f5;
      height: 40px;

      & > div {
        height: -webkit-fill-available;
      }
    }
    .ant-mentions-dropdown-menu-item-active {
      p {
        font-family: var(--font-bold) !important;
      }
    }
    .ant-mentions-dropdown-menu-item-disabled {
      display: none;
    }
  }
`;

export const ContentContainer = styled.div`
  min-height: 20vh;
  width: 100%;
  overflow-y: scroll;
`;

export const NoteSkeletonContainer = styled.div`
  padding: 18px 26px 0 26px;
`;

export const NoteSkeletonTitle = styled.div`
  width: 100%;
  max-width: 139px;
  height: 20px;
  background: #f7f7f7;
  border-radius: 4px;
`;

export const NoteSkeletonSubtitle = styled.div`
  width: 100%;
  height: 20px;
  background: #f7f7f7;
  border-radius: 4px;
  margin-top: 8px;
`;

export const NoteSkeletonContent = styled.div`
  width: 100%;
  height: 142px
  background: #f7f7f7;
  border-radius: 4px;
  margin-top: 8px;
`;

export const NoteSkeletonCounter = styled.div`
  width: 52px;
  height: 16px; 
  background: #f7f7f7;
  border-radius: 4px;
`;
